document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-btn");
  const contents = document.querySelectorAll(".tab-content");

  tabs.forEach(btn => {
    btn.addEventListener("click", function () {
      let tab = this.getAttribute("data-tab");

      tabs.forEach(b => b.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      this.classList.add("active");

      if (tab === "all") {
        document.getElementById("tab-all").classList.add("active");
      } else {
        document.getElementById("tab-month").classList.add("active");
      }
    });
  });
});